import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from './context/ThemeProvider';
import i18n from './i18n';
import Navbar1 from './components/Navbar1';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import CustomerExperiences from './components/CustomerExperiences';
import Footer from './components/Footer';
import LochLomond from './components/LochLomond';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BackToTop from './components/BackToTop';
import './styles/global.css';

const App: React.FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
        <HelmetProvider context={{}}>
          <I18nextProvider i18n={i18n as any}>
            <ThemeProvider>
              <div className="App" data-theme="light">
                <Navbar1 />
                <div className="main-content">
                  <main>
                    <Routes>
                      <Route path="/" element={
                        <>
                          <Hero />
                          <LochLomond />
                          <About />
                          <Services />
                          <Gallery />
                          <Testimonials />
                          <CustomerExperiences />
                        </>
                      } />
                      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    </Routes>
                  </main>
                  <Footer />
                  <BackToTop />
                </div>
              </div>
            </ThemeProvider>
          </I18nextProvider>
        </HelmetProvider>
      </Router>
    </Suspense>
  );
};

export default App; 